export default __webpack_public_path__ + "static/media/lesson-pic1.35114a83.jpg";